(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('feedback', {
                parent: 'entity',
                url: '/feedback?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.feedback.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/feedback/feedbacks.html',
                        controller: 'FeedbackController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'description,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('feedbackType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('feedback-detail', {
                parent: 'entity',
                url: '/feedback/{id}?from',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.feedback.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || 'feedback';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.feedback.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/feedback/feedback-detail.html',
                        controller: 'FeedbackDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('feedbackType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Feedback', function ($stateParams, Feedback) {
                        return Feedback.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'feedback',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('feedback-detail/edit', {
                parent: 'feedback-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('feedback/new', {
                parent: 'feedback',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    description: null,
                                    creationDate: null,
                                    parentId: null,
                                    feedbackType: null,
                                    feedbackAnswer: null,
                                    satisfied: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('feedback');
                    });
                }]
            })
            .state('feedback/edit', {
                parent: 'feedback',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('feedback/delete', {
                parent: 'feedback',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-delete-dialog.html',
                        controller: 'FeedbackDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
